(() => {
  const CARD_SELECTOR = 'product-card';
  let cartState = null;
  const busyCards = new Set();

  async function fetchCart(forceRefresh = false) {
    const bust = forceRefresh ? '?t=' + Date.now() : '';
    const res = await fetch('/cart.js' + bust, {
      headers: { Accept: 'application/json' },
      cache: forceRefresh ? 'no-store' : 'default'
    });
    cartState = await res.json();
    return cartState;
  }

  function getVariantId(card) {
    return card.querySelector('input[name="id"]')?.value;
  }

  function getCardPrice(card) {
    const dataPrice =
      card.querySelector('[data-gg-global-product-price]')?.getAttribute('data-gg-global-product-price') ||
      card.querySelector('add-to-cart-component')?.getAttribute('data-gg-global-product-price');

    if (dataPrice && dataPrice.trim()) return dataPrice.trim();

    const priceEl =
      card.querySelector('.product-card__content > .price') ||
      card.querySelector('.price .price-item--regular') ||
      card.querySelector('.price .price-item') ||
      card.querySelector('.price');

    return priceEl ? priceEl.textContent.trim() : '';
  }

  function getQty(variantId) {
    if (!cartState) return 0;
    const item = cartState.items.find(i => String(i.variant_id) === String(variantId));
    return item ? item.quantity : 0;
  }

  function updateHeaderCount() {
    if (!cartState) return;
    document
      .querySelectorAll('[data-gg-cart-count], cart-count, .cart-count-bubble span, .cart-count')
      .forEach(el => {
        el.textContent = cartState.item_count || 0;
        el.removeAttribute('hidden');
      });
  }

  function ensurePremiumRow(card) {
    const quickAdd = card.querySelector('quick-add-component');
    if (!quickAdd) return null;

    let row = quickAdd.querySelector('.gg-buy-row');

    if (!row) {
      row = document.createElement('div');
      row.className = 'gg-buy-row';

      const price = document.createElement('span');
      price.className = 'gg-buy-row__price';
      price.textContent = getCardPrice(card);

      const slot = document.createElement('div');
      slot.className = 'gg-buy-row__slot';

      const nativeButton = quickAdd.querySelector('.quick-add__button');
      if (nativeButton) slot.appendChild(nativeButton);

      row.appendChild(price);
      row.appendChild(slot);
      quickAdd.appendChild(row);
    }

    return row;
  }

  function ensureQtyControl(card) {
    const row = ensurePremiumRow(card);
    if (!row) return null;

    const slot = row.querySelector('.gg-buy-row__slot');
    let control = slot.querySelector('.gg-card-qty');

    if (!control) {
      control = document.createElement('div');
      control.className = 'gg-card-qty';
      control.innerHTML = `
        <button type="button" class="gg-card-qty__minus" aria-label="Diminuer">−</button>
        <span class="gg-card-qty__count">0</span>
        <button type="button" class="gg-card-qty__plus" aria-label="Ajouter">+</button>
      `;
      slot.appendChild(control);
    }

    return control;
  }

  function renderCard(card) {
    const variantId = getVariantId(card);
    if (!variantId) return;

    const row = ensurePremiumRow(card);
    const control = ensureQtyControl(card);
    if (!row || !control) return;

    const price = row.querySelector('.gg-buy-row__price');
    const priceText = getCardPrice(card);
    if (price) price.textContent = priceText;
    card.classList.toggle('gg-price-ready', Boolean(priceText));

    const qty = getQty(variantId);
    control.querySelector('.gg-card-qty__count').textContent = qty;

    if (qty > 0) {
      card.classList.add('gg-has-qty');
      control.classList.add('is-visible');
    } else {
      card.classList.remove('gg-has-qty');
      control.classList.remove('is-visible');
    }
  }

  function renderAll() {
    document.querySelectorAll(CARD_SELECTOR).forEach(renderCard);
    updateHeaderCount();
  }

  async function addVariant(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });

    if (!res.ok) throw new Error('Erreur ajout panier');
    await fetchCart(true);
    renderAll();
  }

  async function setVariantQuantity(variantId, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(variantId), quantity: Math.max(0, quantity) })
    });

    if (!res.ok) throw new Error('Erreur modification quantité');
    cartState = await res.json();
    renderAll();
  }

  function optimisticAdd(variantId) {
    const item = cartState.items.find(i => String(i.variant_id) === String(variantId));
    if (item) item.quantity += 1;
    else cartState.items.push({ variant_id: Number(variantId), quantity: 1 });

    cartState.item_count = (cartState.item_count || 0) + 1;
    renderAll();
  }

  function optimisticMinus(variantId, currentQty) {
    const nextQty = Math.max(0, currentQty - 1);
    const item = cartState.items.find(i => String(i.variant_id) === String(variantId));

    if (item) item.quantity = nextQty;
    cartState.item_count = Math.max(0, (cartState.item_count || 0) - 1);

    renderAll();
    return nextQty;
  }

  document.addEventListener('click', async event => {
    const buyBtn = event.target.closest('product-card .quick-add__button');
    const plusBtn = event.target.closest('.gg-card-qty__plus');
    const minusBtn = event.target.closest('.gg-card-qty__minus');

    if (!buyBtn && !plusBtn && !minusBtn) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const card = event.target.closest(CARD_SELECTOR);
    if (!card) return;

    const variantId = getVariantId(card);
    if (!variantId) return;

    if (busyCards.has(variantId)) return;
    busyCards.add(variantId);

    try {
      if (!cartState) await fetchCart();

      const currentQty = getQty(variantId);

      if (buyBtn || plusBtn) {
        optimisticAdd(variantId);
        await addVariant(variantId);
      }

      if (minusBtn) {
        const nextQty = optimisticMinus(variantId, currentQty);
        await setVariantQuantity(variantId, nextQty);
      }
    } catch (error) {
      console.error('[GG COLLECTION CART]', error);
      await fetchCart(true);
      renderAll();
    } finally {
      busyCards.delete(variantId);
    }
  }, true);

  async function init() {
    await fetchCart(false);
    renderAll();
  }

  let moTimer = null;
  const observer = new MutationObserver(() => {
    clearTimeout(moTimer);
    moTimer = setTimeout(() => {
      if (cartState) renderAll();
    }, 220);
  });

  document.addEventListener('DOMContentLoaded', () => {
    init();
    const productGrid = document.querySelector('ul[ref="grid"], .product-grid, results-list');
    if (productGrid) {
      observer.observe(productGrid, { childList: true, subtree: true });
    } else {
      observer.observe(document.body, { childList: true, subtree: false });
    }
  });
  document.addEventListener('shopify:section:load', init);
})();